module.exports = __webpack_public_path__ + "static/media/skills.826d201f.svg";